import { render, staticRenderFns } from "./LackMaterialCallModal.vue?vue&type=template&id=e44043a6&scoped=true"
import script from "./LackMaterialCallModal.vue?vue&type=script&lang=ts"
export * from "./LackMaterialCallModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44043a6",
  null
  
)

export default component.exports